import { render, staticRenderFns } from "./absenceDashTeacher.vue?vue&type=template&id=0d8d812a&"
import script from "./absenceDashTeacher.vue?vue&type=script&lang=js&"
export * from "./absenceDashTeacher.vue?vue&type=script&lang=js&"
import style0 from "./absenceDashTeacher.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports